import React, { useEffect, useState } from 'react';
import Scheduler from '../../components/Scheduler/index';
import { useSelector, useDispatch } from 'react-redux';
import moment from 'moment';
import { createSchedule, getSchedule, toggleUpdateMode, updateSchedule, cancelSchedule, confirmSchedule, onValueChange } from '../../services/create_schedule/actions';
import DateRangeIcon from '@material-ui/icons/DateRange';
import InviteForm from './InviteForm';
import NotificationModal from './../../components/NotificationModal/index';
import ConfirmationPopup from '../../components/ConfirmationPopup/index';
import actionConstants from '../../services/create_schedule/constants';
import PagePreloader from '../../components/PagePreloader/index';
import { SuccessMessage, InfoMessage } from '../../components/Messages/index';
import ActionButton from '../../components/ActionButton/index';
import { getSchedulesJSON, hasEmptyDays, getSanitizedSchedule } from '../../services/scheduler/utils';
import ContactForm from '../../components/ContactForm/index';
import ContactInfo from '../../components/ContactInfo/index';
import AddressModal from '../../components/AddressForm/AddressModal';
import { setAddress } from '../../services/scheduler/actions';

const CreateSchedule = (props) => {
    const {
        receiver,
        specialInstructions,
        sentAt,
        bookedAt,
        eventName,
        isUpdateMode,
        isCancelMessageVisible,
        buyerSchedules,
        isSuccesMessageVisible: isModalVisible,
        pending,
        isBooked,
        sellerEmail,
        sellerName,
        sellerPhone,
        hostPhoneExtension,
        buyerName,
        buyerPhone,
        attendeeSchedulesList,        
    } = useSelector((state) => state.scheduleCreationData);
    const eventId = props.match.params.guid;
    const schedule = useSelector(state => state.scheduler.schedule);
    const address = useSelector(state => state.scheduler.address);
    const activeDay = useSelector(state => state.scheduler.activeDateSlot)
    const [cancelOpened, toggleCancelModalState] = useState(false);
    const [warningMessage, setWarningMessage] = useState('');
    const [isSubmitted, setSubmitFlag] = useState(false);
    const [instructions, setInstructions] = useState('');
    const [IsCheckSlotDetailsFill, setIsCheckSlotDetailsFill] = useState(false);
    const [isRequiredName, setIsRequiredName] = useState(false);
    const [isEmptySeats, setIsEmptySeats] = useState(false);
    const [isWaitingList, setIsWaitingList] = useState(false);

    const hasSomeSlots =
        Object.values(schedule)
            .some(el => el.length);

    const dispatch = useDispatch();

    useEffect(() => {
        getSchedule(eventId)(dispatch);
    }, [eventId, dispatch])

    useEffect(() => {
        if (hasEmptyDays(schedule)) {
            setWarningMessage('You have not selected time slots for some of your available dates.');
        } else {
            setWarningMessage('');
        }
        var isEmpty = CheckEmptySeatValidation();
        setIsEmptySeats(isEmpty);

    }, [schedule])

    const getCustomTimeslots = () => {
        if (!buyerSchedules) return null;
        const schedule = getSanitizedSchedule(buyerSchedules);
        return schedule[activeDay] || [];
    }

    const getContactInfo = () => {
        const info = {};
        if (sellerName) {
            info.sellerName = sellerName;
        }

        if (sellerPhone) {
            info.sellerPhone = sellerPhone;
        }

        return info;
    };

    const CheckSlotDetailsFill = (value) => {
        //setIsCheckSlotDetailsFill(value);
        var isEmpty = CheckEmptySeatValidation();
        setIsEmptySeats(isEmpty);
    }

    const onChange = (name) => (value) => {
        if (name == "sellerName") {
            value = value.replace(/[^A-Z a-z]/ig, '')
        }
        
        if (name == "hostPhoneExtension") {
            value = value.replace(/[^0-9 ()+]/ig, '')
         }
        dispatch(onValueChange({ name, value }))
    };

    const handleSubmit = (formData = {}) => {
        var clonedSchedule = getSchedulesJSON(schedule);
        clonedSchedule.forEach(function (item) {
            item.time.map((time) => delete time.isAvailableSeatsPopOverOpened)
        });
        const requestData = {
            schedules: clonedSchedule,
            receiver: receiver || formData.email,
            specialInstructions: instructions || specialInstructions || formData.instructions,
            eventlocation: formData.eventlocation,
            hostPhoneExtension: hostPhoneExtension,
            eventId,
            address,
            ...getContactInfo()
        }

        if (buyerSchedules) {
            const { date, time } = getSchedulesJSON(schedule)[0] || {};
            const requestData = {
                datetime: (new Date(`${date} ${time[0].split(' ')[0]}`)).toISOString(),
                buyerEmail: receiver,
                eventId,
                schedules: getSchedulesJSON(schedule)
            }
            //confirmSchedule(requestData)(dispatch);
            return;
        }

        setSubmitFlag(true);
        if (hasEmptyDays(schedule)) return;

        if (isUpdateMode) {
            updateSchedule(requestData)(dispatch);
        } else {
            createSchedule(requestData)(dispatch);
        }
    }

    const handleCancel = () => {
        cancelSchedule({ eventId })(dispatch);
        toggleCancelModalState(false);
    };

    const getReadOnlyOptions = () => {
        return receiver && { receiver, specialInstructions }
    }

    const isReadOnlyMode = () => {
        return (!isUpdateMode && receiver)
            || isBooked;
    }

    const onValidateControls = (name, value) => {
        if (name === "hostname") {
            setIsRequiredName(value)
        }

        if (name === "emptyseats") {
            var isEmpty = CheckEmptySeatValidation();
            setIsEmptySeats(isEmpty);
        }
    }
    const handleChange = (flag) => {
        dispatch(toggleUpdateMode(flag));
    }

    const CheckEmptySeatValidation = () => {
        var IsEmptySeats = false;
        var SchedulesJSON = getSchedulesJSON(schedule);
        if (SchedulesJSON && SchedulesJSON.length > 0) {
            SchedulesJSON.map((item) => {
                if (item.time) {
                    for (let i = 0; i < item.time.length; i++) {
                        if (item.time[i].seats === undefined || item.time[i].seats === null || item.time[i].seats === "" || item.time[i].seats === 0) {
                            IsEmptySeats = true;
                        }
                    }
                }


            });
        }

        return IsEmptySeats;
    }

    const contactFormRenderer = () => {
        return (

            //<AddressModal
            //    handleSubmit={(data) => dispatch(setAddress(data))}
            //    defaultAddress={address}
            //    disabled={(!isUpdateMode && receiver) && !isBooked}
            //    readOnly={isBooked}
            ///>
            <div>
                {!buyerSchedules && !isBooked && (
                    <ContactForm
                        name={sellerName}
                        setName={onChange('sellerName')}
                        phone={sellerPhone}
                        setPhone={onChange('sellerPhone')}
                        disabled={!!isReadOnlyMode()}
                        isRequiredName={(sellerName === null ? isRequiredName : !sellerName)}
                        extension={hostPhoneExtension}
                        setExtension={onChange('hostPhoneExtension')}
                    />
                )}
            </div>
        );
    };

    const AddressFormRenderer = () => {
        return (

            <AddressModal
                handleSubmit={(data) => dispatch(setAddress(data))}
                defaultAddress={address}
                disabled={(!isUpdateMode && receiver) && !isBooked}
                readOnly={isBooked}
            />



        );
    };


    const renderSubmitForm = () => {
        let inactiveMessage = '';
        //if (!address) {
        //    inactiveMessage = 'Please select an address';
        //}
        var clonedSchedule = getSchedulesJSON(schedule);
        var valid = CheckEmptySeatValidation();
        if (!hasSomeSlots) {
            inactiveMessage = 'Please select your available hours';
        }
        //if (sellerName === "" || sellerName === null) {
        //    inactiveMessage = 'Please fill other required fields.';
        //}
        //if (hasSomeSlots && IsCheckSlotDetailsFill === false) {
        //    inactiveMessage = 'Please fill selected slot details';
        //}
        return (
            <InviteForm
                isUpdateMode={isUpdateMode}
                readOnlyOptions={getReadOnlyOptions()}
                onSubmit={handleSubmit}
                inactiveMessage={inactiveMessage}
                onInstructionsChange={isUpdateMode ? setInstructions : undefined}
                warningMessage={isSubmitted && warningMessage}
                additionalFieldsRenderer={contactFormRenderer}
                addressFieldsRenderer={AddressFormRenderer}
                eventName={eventName}
                sellerName={sellerName}
                onValidateControls={(name, value) => onValidateControls(name, value)}
                isEmptySeats={isEmptySeats}
                sellerEmail={sellerEmail}
            />
        );
    }

    const getContactForm = () => {        
        return (            
            <ContactInfo
                title='Host Contact Information'
                email={sellerEmail}
                name={buyerName}
                phone={buyerPhone}
                extension={hostPhoneExtension}
                isAttendeeView={true}
            />
        );
    }
    const renderPageActions = () => {
        if (isBooked) return null;

        if (!isUpdateMode && !buyerSchedules) return null;

        return (
            <div className='page-actions'>
                {buyerSchedules && (
                    <ActionButton
                        onClick={handleSubmit}
                        title='Confirm'
                        disableError={(!hasSomeSlots && 'Please select your available hours')}
                    />
                )}
                {isUpdateMode && (
                    <ActionButton
                        disableError={(!hasSomeSlots && 'Please select your available hours') || warningMessage}
                        onClick={handleSubmit}
                        title='Send update'
                    />
                )}
                <ActionButton onClick={() => toggleCancelModalState(true)} title='Cancel event' />
            </div>
        );
    }

    const getSuccessMessage = () => {
        return isUpdateMode
            ? `${eventName} was successfully updated.`
            : `Invite for ${eventName} has been successfully sent.`
    }

    const getTitle = () => {
        if (isBooked) {
            return (
                <span>
                    Scheduled Date/Time
        </span>
            );
        }
        if (buyerSchedules) {
            return (
                <span>
                    Confirm proposed Date/Time or cancel event
        </span>
            );
        }


        if ((!isUpdateMode && receiver)) {
            return (
                <span>
                    View Schedule
        </span>
            );
        }

        return isUpdateMode
            ? 'Updating an Event'
            : 'Create Schedule';
    }

    if (pending) {
        return <PagePreloader />;
    }
    const CheckWaitingList = (dateSlot, timeSlot) => {
        setIsWaitingList(false);
    }

    return (
        <div className='page create-schedule'>
            {isBooked && (
                <SuccessMessage
                    title={
                        <span>{eventName} event was successfully scheduled</span>
                    }
                />
            )}
            <div className='page-bar'>
                {isUpdateMode && (
                    <>
                        <h3 className='page-title'><DateRangeIcon /> {getTitle()}</h3>
                        <h3 className="user-title">{eventName}</h3>
                    </>
                )
                }

                {!isUpdateMode && receiver && (
                    <>

                        <h3 className='page-title'><DateRangeIcon /> Manage Event Schedule</h3>
                    </>
                )

                }

                {
                    !isReadOnlyMode() && (
                    <>
                        <h3 className='page-title'><DateRangeIcon /> Create Schedule</h3>
                        <h3 className="user-title">{eventName}</h3>
                    </>
                        )
        }

                {renderPageActions()}
            </div>

            {
                //    !isUpdateMode && receiver && (
                //    <div>
                //        <b>Event Name: {eventName}</b>
                //    </div>
                //)
            }

            {
                //!isReadOnlyMode() && <h3 className='page-title'>Specify the date of your event.</h3>
            }

            <Scheduler
                readOnly={(isReadOnlyMode() && !buyerSchedules) || isBooked}
                submitSenderer={renderSubmitForm}
                customTimeSlots={getCustomTimeslots()}
                hoursMultiselect={!buyerSchedules}
                //hoursMultiselect={false}
                attendeeSchedulesList={attendeeSchedulesList}
                eventName={eventName}
                CheckSlotDetailsFill={(e) => CheckSlotDetailsFill(e)}
                contactform={getContactForm()}
                eventId={eventId}
                CheckWaitingList={(day, time) => CheckWaitingList(day, time)}
                isHost={true}
            />

            {isBooked && (
                <div style={{ marginBottom: '15px' }}>
                    <ActionButton onClick={() => toggleCancelModalState(true)} title='Cancel event' />
                </div>
            )}

            {/*<div className='scheduler'>
                <div className='scheduler__left'>
                    <ContactInfo
                        title='Attendee Contact Information'
                        email={receiver}
                        name={buyerName}
                        phone={buyerPhone}
                    />
                </div>
            </div>*/}
            {!((isReadOnlyMode() && !buyerSchedules) || isBooked) && (
                //<ContactInfo
                //    title='Host Contact Information'
                //    email={sellerEmail}
                //    name={buyerName}
                //    phone={buyerPhone}
                //    isAttendeeView={true}
                ///>

                getContactForm()
            )
            }

            {receiver && !buyerSchedules && !isBooked && (
                <InfoMessage
                    logger
                    title={(
                        <span>
                            {
                                //Notification was sent to {receiver} on {moment(moment.utc(sentAt).toDate()).local().format('MM/DD/YYYY HH:mm A')} with event details.
                            }

                            Notification was sent to your attendees on {moment(moment.utc(sentAt).toDate()).local().format('MM/DD/YYYY')} at {moment(moment.utc(sentAt).toDate()).local().format('HH:mm a')} with event details. 

              {
                                //                !isUpdateMode && (
                                //                 <span>
                                //                    & nbsp;If you wish to change availability schedule or cancel the event,&nbsp;
                                //  <span onClick={() => handleChange(true)} className='changer-link' href='#'>click here</span>.
                                //</span> 
                                //                )
                            }
                        </span>
                    )}
                />
            )}

            {isBooked && (
                <InfoMessage
                    logger
                    title={(
                        <span>
                            Email Notification with {eventName} event details was sent to {sellerEmail} on {moment(moment.utc(bookedAt).toDate()).local().format('MM/DD/YYYY HH:mm A')}.
            </span>
                    )}
                />
            )}

            <NotificationModal
                titleRenderer={() => (
                    <SuccessMessage
                        title={`${eventName} was successfully canceled.`}
                    />
                )}
                descriptionRenderer={() => (
                    <div className='notification-description'>
                        {receiver} will receive email notification.
          </div>
                )}
                isOpened={isCancelMessageVisible}
            />


            <NotificationModal
                titleRenderer={() => (
                    <SuccessMessage
                        title={getSuccessMessage()}
                    />
                )}
                descriptionRenderer={() => (
                    <div className='notification-description'>
                        {//receiver} 
                            //will receive email notification.
                        }
                            Your attendees will receive email notification. 

          </div>
                )}
                isOpened={isModalVisible}
                handleClose={() => {
                    handleChange(false);
                    dispatch({ type: actionConstants.HIDE_SCHEDULE_CREATION_SUCCESS_MESSAGE })
                }}
            />

            <ConfirmationPopup
                title={'Confirm cancelation'}
                description={'Are you sure you want to cancel this event?'}
                handleConfirm={handleCancel}
                handleClose={() => toggleCancelModalState(false)}
                opened={cancelOpened}
            />
        </div>
    )
}

export default CreateSchedule;